<template>
    <div class="order-page">
        <div class="container">
            <div class="handle-box">
                <div class="handle-box-left">
                    <el-input placeholder="请输入手机号或提货码或订单号" v-model="str" class="search-input"></el-input>
                    <el-select v-model="status" placeholder="请选择订单状态" class="search-select"
                        @change="onChangeOrderStatus">
                        <el-option v-for="item in selectStatus" :key="item.status" :label="item.name" :value="item.status">
                        </el-option>
                    </el-select>
                    <el-button type="primary" @click="handleSearch" icon="el-icon-search" :disabled="disfle"
                        :loading="lod">搜索
                    </el-button>
                </div>
                <div class="button-view">
                    <span class="live-tag" :class="{ 'live-on': liveStatus === 'connected', 'live-off': liveStatus === 'disconnected', 'live-reconnecting': liveStatus === 'reconnecting' }">
                        <span class="live-dot"></span>
                        {{ liveStatus === 'connected' ? '实时监听中' : liveStatus === 'reconnecting' ? '重连中...' : '连接已断' }}
                    </span>
                    <el-badge :value="dingdan" :hidden="dingdan==0" :max="99" class="item" type="warning">
                        <el-button size="small" @click="refresh_order()">刷新订单</el-button>
                    </el-badge>
                    <el-button size="small" type="warning" icon="el-icon-key" style="margin-left:12px" @click="handleVerifyPickUp(null, null)">核销提货</el-button>
                </div>
            </div>
            <el-table :data="tableData" border class="table table-then-card" ref="filterTable" v-loading="loading"
                :row-class-name="rowClassName">
                <el-table-column prop="orderTime" label="下单时间" align="center" fixed="left"
                    width="150"></el-table-column>
                <el-table-column prop="status" label="订单状态" width="120" align="center" fixed="left">
                    <template slot-scope="scope">
                        <template v-if="scope.row.status == 1">
                            <el-tag effect="dark" type="warning">
                                待付款
                            </el-tag>
                        </template>
                        <template v-if="scope.row.status == 2">
                            <el-tag effect="dark">
                                待发货
                            </el-tag>
                        </template>
                        <template v-if="scope.row.status == 3">
                            <el-tag effect="dark">
                                待收货
                            </el-tag>
                        </template>
                        <template v-if="scope.row.status == 4">
                            <el-tag effect="dark" type="danger">
                                申请退款
                            </el-tag>
                        </template>
                        <template v-if="scope.row.status == 5">
                            <el-tag effect="dark" type="danger">
                                已退款
                            </el-tag>
                        </template>
                        <template v-if="scope.row.status == 6">
                            <el-tag effect="dark" type="success">
                                已完成
                            </el-tag>
                        </template>
                        <template v-if="scope.row.status == 7">
                            <el-tag effect="dark" type="info">
                                已取消
                            </el-tag>
                        </template>
                        <template v-if="scope.row.status == 8">
                            <el-tag effect="dark">
                                待提货
                            </el-tag>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="剩余支付时间" width="130" align="center" fixed="left">
                    <template slot-scope="scope">
                        <template v-if="scope.row.status == 1">
                            <span style="color: #ff2000; font-weight: bold;">{{ countdownData[scope.row.oid] || '-' }}</span>
                        </template>
                        <template v-else>
                            <span style="color: #999;">-</span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="psMode" label="配送方式" align="center" fixed="left" width="90">
                    <template slot-scope="scope">
                        <template v-if="scope.row.psMode == 1">
                            <el-tag>
                                自提
                            </el-tag>
                        </template>
                        <template v-if="scope.row.psMode == 2">
                            <el-tag type="success">
                                配送
                            </el-tag>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="orderNum" label="订单编号" width="200"></el-table-column>
                <el-table-column prop="nickname" label="下单用户" width="150" align="center" class-name="mobile-hide"></el-table-column>
                <el-table-column prop="uphone" label="联系方式" width="150" class-name="mobile-hide"></el-table-column>
                <el-table-column prop="payStatus" label="支付状态" width="120" align="center" class-name="mobile-hide">
                    <template slot-scope="scope">
                        <template v-if="scope.row.payStatus == 0">
                            <el-tag effect="dark" type="warning">
                                未支付
                            </el-tag>
                        </template>
                        <template v-if="scope.row.payStatus == 1">
                            <el-tag effect="dark" type="success">
                                已支付
                            </el-tag>
                        </template>
                        <template v-if="scope.row.payStatus == 2">
                            <el-tag effect="dark" type="danger">
                                已退款
                            </el-tag>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="goodPrice" label="商品总价" width="100" align="center" class-name="mobile-hide"></el-table-column>
                <el-table-column prop="freight" label="运 费" width="100" align="center" class-name="mobile-hide"></el-table-column>
                <el-table-column prop="credit" label="抵扣积分" width="120" align="center" class-name="mobile-hide">
                    <template slot-scope="scope">
                        {{ scope.row.credit != 0 ? scope.row.credit : 0 }}
                    </template>
                </el-table-column>
                <el-table-column prop="money"  label="付款金额(元)"  align="center"
                    fixed="right"></el-table-column>
                <el-table-column label="操作" width="200" align="center" fixed="right">
                    <template slot-scope="scope">
                        <template v-if="scope.row.status == 2">
                            <el-button type="text" icon="el-icon-position"
                                @click="handleOrderSipping(scope.$index, scope.row)">
                                确认发货
                            </el-button>
                        </template>
                        <template v-if="scope.row.status == 8">
                            <el-button type="text" icon="el-icon-circle-check" style="color:#e6a23c"
                                @click="handleVerifyPickUp(scope.$index, scope.row)">
                                核销提货
                            </el-button>
                            <el-button type="text" icon="el-icon-success" style="color:green"
                                @click="handleOrderStatus(scope.$index, scope.row)">
                                确认完成
                            </el-button>
                        </template>
                        <template v-if="scope.row.status == 4">
                            <el-button type="text" icon="el-icon-success" style="color:green"
                                @click="handleOrderStatus(scope.$index, scope.row, 0)">
                                同意
                            </el-button>
                            <el-button type="text" icon="el-icon-close" style="color:#ff2000"
                                @click="handleOrderStatus(scope.$index, scope.row, 1)">
                                拒绝
                            </el-button>
                        </template>
                        <el-button type="text" icon="el-icon-view" @click="handleLook(scope.$index, scope.row)">
                            详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 手机端卡片列表 -->
            <div class="mobile-card-list" v-loading="loading">
                <div v-for="(row, idx) in tableData" :key="row.oid"
                    class="mc-card" :class="{ 'mc-new': newOrderIds.includes(row.oid) }">
                    <div class="mc-header">
                        <div class="mc-header-left">
                            <el-tag effect="dark" :type="statusTagType(row.status)" size="small">{{ statusText(row.status) }}</el-tag>
                            <el-tag v-if="row.psMode == 1" size="small">自提</el-tag>
                            <el-tag v-else-if="row.psMode == 2" type="success" size="small">配送</el-tag>
                            <el-tag v-if="row.isAnonymous == 1" size="small" type="danger">匿名</el-tag>
                        </div>
                        <span class="mc-subtitle">{{ row.orderTime }}</span>
                    </div>
                    <div class="mc-row">
                        <span class="mc-label">订单编号</span>
                        <span class="mc-value">{{ row.orderNum }}</span>
                    </div>
                    <div class="mc-grid-2">
                        <div class="mc-row">
                            <span class="mc-label">付款金额</span>
                            <span class="mc-value mc-value-bold">¥{{ row.money }}</span>
                        </div>
                        <div class="mc-row" v-if="row.status == 1">
                            <span class="mc-label">剩余时间</span>
                            <span class="mc-value mc-value-danger">{{ countdownData[row.oid] || '-' }}</span>
                        </div>
                        <div class="mc-row">
                            <span class="mc-label">下单用户</span>
                            <span class="mc-value">{{ row.nickname || '-' }}</span>
                        </div>
                        <div class="mc-row">
                            <span class="mc-label">联系方式</span>
                            <span class="mc-value">{{ row.uphone || '-' }}</span>
                        </div>
                        <div class="mc-row">
                            <span class="mc-label">支付状态</span>
                            <el-tag effect="dark" :type="payStatusTagType(row.payStatus)" size="small">{{ payStatusText(row.payStatus) }}</el-tag>
                        </div>
                    </div>
                    <div class="mc-actions">
                        <el-button v-if="row.status == 2" type="primary" size="small" icon="el-icon-position"
                            @click="handleOrderSipping(idx, row)">确认发货</el-button>
                        <el-button v-if="row.status == 8" type="warning" size="small" icon="el-icon-circle-check"
                            @click="handleVerifyPickUp(idx, row)">核销提货</el-button>
                        <el-button v-if="row.status == 8" type="success" size="small" icon="el-icon-success"
                            @click="handleOrderStatus(idx, row)">确认完成</el-button>
                        <el-button v-if="row.status == 4" type="success" size="small" icon="el-icon-success"
                            @click="handleOrderStatus(idx, row, 0)">同意</el-button>
                        <el-button v-if="row.status == 4" type="danger" size="small" icon="el-icon-close"
                            @click="handleOrderStatus(idx, row, 1)">拒绝</el-button>
                        <el-button size="small" icon="el-icon-view"
                            @click="handleLook(idx, row)">详情</el-button>
                    </div>
                </div>
                <div v-if="!loading && tableData.length === 0" style="text-align:center;color:#909399;padding:30px 0;">暂无数据</div>
            </div>
            <div class="pagination">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="page" :page-size="size"
                    layout="total, prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="发货信息" :visible.sync="fhFlag" :width="dialogWidthSmall">
            <el-form label-position="left" :rules="ruless" ref="fhObj" label-width="100px" :model="fhObj" status-icon>
                <el-form-item label="发货单号" prop="trackingNumber">
                    <el-input placeholder="请输入发货单号" prefix-icon="el-icon-edit"
                        v-model="fhObj.trackingNumber"></el-input>
                </el-form-item>
                <el-form-item label="配送公司" prop="logisticsCompany">
                    <el-input placeholder="请输入配送公司" prefix-icon="el-icon-edit"
                        v-model="fhObj.logisticsCompany"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="subFh('fhObj')">确 定</el-button>
                <el-button @click="fhFlag = false">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="核销提货" :visible.sync="verifyFlag" :width="dialogWidthSmall" @close="verifyPickCode=''">
            <el-form label-position="left" :rules="verifyRules" ref="verifyForm" label-width="100px" :model="{pickCode: verifyPickCode}" status-icon>
                <el-form-item label="提货码" prop="pickCode">
                    <el-input placeholder="请输入提货码" prefix-icon="el-icon-key"
                        v-model="verifyPickCode"></el-input>
                </el-form-item>
                <div v-if="verifyOrderInfo" style="background:#f5f7fa;padding:10px;border-radius:4px;margin-bottom:16px;">
                    <div style="font-size:13px;color:#606266;margin-bottom:6px;">订单信息确认</div>
                    <div>订单号：{{ verifyOrderInfo.orderNum }}</div>
                    <div>下单用户：{{ verifyOrderInfo.nickname || '-' }}</div>
                    <div>付款金额：¥{{ verifyOrderInfo.money }}</div>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="subVerify" :loading="verifyLoading">确认核销</el-button>
                <el-button @click="verifyFlag = false">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="订单信息" :visible.sync="xx" :width="dialogWidth">
            <el-tabs v-model="activeName" type="border-card">
                <el-tab-pane label="详细信息" name="first">
                    <el-descriptions size="medium">
                        <el-descriptions-item label="下单时间">
                            {{ obj.orderTime }}
                        </el-descriptions-item>
                        <el-descriptions-item label="付款时间" v-if="obj.playTime">
                            {{ obj.playTime }}
                        </el-descriptions-item>
                        <el-descriptions-item label="成交时间" v-if="obj.closingTime">
                            {{ obj.closingTime }}
                        </el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions>
                        <el-descriptions-item label="订单号">{{ obj.orderNum }}</el-descriptions-item>
                        <el-descriptions-item label="下单用户">
                            {{ obj.nickname }}
                        </el-descriptions-item>
                        <el-descriptions-item label="注册手机号">
                            {{ obj.uphone }}
                        </el-descriptions-item>
                        <el-descriptions-item label="订单状态">
                            <template v-if="obj.status == 1">
                                <el-tag effect="dark" type="warning" size="small">
                                    待付款
                                </el-tag>
                            </template>
                            <template v-if="obj.status == 2">
                                <el-tag effect="dark" size="small">
                                    待发货
                                </el-tag>
                            </template>
                            <template v-if="obj.status == 3">
                                <el-tag effect="dark" size="small">
                                    待收货
                                </el-tag>
                            </template>
                            <template v-if="obj.status == 4">
                                <el-tag effect="dark" type="danger" size="small">
                                    申请退款
                                </el-tag>
                            </template>
                            <template v-if="obj.status == 5">
                                <el-tag effect="dark" type="danger" size="small">
                                    已退款
                                </el-tag>
                            </template>
                            <template v-if="obj.status == 6">
                                <el-tag effect="dark" type="success" size="small">
                                    已完成
                                </el-tag>
                            </template>
                            <template v-if="obj.status == 7">
                                <el-tag effect="dark" type="info" size="small">
                                    已取消
                                </el-tag>
                            </template>
                            <template v-if="obj.status == 8">
                                <el-tag effect="dark" size="small">
                                    待提货
                                </el-tag>
                            </template>
                        </el-descriptions-item>
                        <el-descriptions-item label="支付状态">
                            <template v-if="obj.payStatus == 0">
                                <el-tag effect="dark" type="warning" size="small">
                                    未支付
                                </el-tag>
                            </template>
                            <template v-if="obj.payStatus == 1">
                                <el-tag effect="dark" type="success" size="small">
                                    已支付
                                </el-tag>
                            </template>
                            <template v-if="obj.payStatus == 2">
                                <el-tag effect="dark" type="danger" size="small">
                                    已退款
                                </el-tag>
                            </template>
                        </el-descriptions-item>
                        <el-descriptions-item label="配送方式">
                            <template v-if="obj.psMode == 1">
                                <el-tag size="small">
                                    自提
                                </el-tag>
                            </template>
                            <template v-if="obj.psMode == 2">
                                <el-tag type="success" size="small">
                                    配送
                                </el-tag>
                            </template>
                        </el-descriptions-item>
                        <el-descriptions-item label="商品总价">
                            {{ obj.goodPrice }}
                        </el-descriptions-item>
                        <el-descriptions-item label="运 费">
                            {{ obj.freight }}
                        </el-descriptions-item>
                        <el-descriptions-item label="抵扣积分">
                            {{ obj.credit }}({{ (obj.credit / 100).toFixed(2) + '元' }})
                        </el-descriptions-item>
                        <el-descriptions-item label="付款金额">
                            <el-link type="danger">{{ obj.money }}</el-link>
                        </el-descriptions-item>
                    </el-descriptions>



                    <el-descriptions title="发货信息" v-if="obj.trackingNumber" :column="2">
                        <el-descriptions-item label="发货单号">{{ obj.trackingNumber }} </el-descriptions-item>
                        <el-descriptions-item label="配送公司">
                            <el-tag size="small">
                                {{ obj.logisticsCompany }}
                            </el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="发货时间">{{ obj.shipTime }} </el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions title="收货信息" v-if="obj.psMode == 2" :column="2" border class="hide-on-mobile">
                        <el-descriptions-item label="收货人">{{ obj.recipientName}}</el-descriptions-item>
                        <el-descriptions-item label="联系电话">{{ obj.recipientPhone }}</el-descriptions-item>
                        <el-descriptions-item label="收货地址">{{ obj.recipientAddress }}</el-descriptions-item>
                    </el-descriptions>
                    <div v-if="obj.psMode == 2" class="recipient-copy-pc hide-on-mobile" style="margin-top:4px;">
                        <el-button size="mini" icon="el-icon-document-copy" @click="copyRecipientInfo">复制收货信息</el-button>
                    </div>
                    <!-- 手机端收货信息卡片 -->
                    <div v-if="obj.psMode == 2" class="recipient-card hide-on-pc">
                        <div style="font-size:14px;font-weight:600;color:#303133;margin-bottom:10px;">收货信息</div>
                        <div class="recipient-card-header">
                            <div>
                                <span class="recipient-card-name">{{ obj.recipientName }}</span>
                                <span class="recipient-card-phone">{{ obj.recipientPhone }}</span>
                            </div>
                        </div>
                        <div class="recipient-card-address">{{ obj.recipientAddress }}</div>
                        <div class="recipient-card-copy">
                            <el-button size="small" icon="el-icon-document-copy" @click="copyRecipientInfo">一键复制收货信息</el-button>
                        </div>
                    </div>
                    <el-descriptions title="提货信息" v-if="obj.psMode == 1" :column="2">
                        <el-descriptions-item label="提货码">
                            <span v-if="obj.pickCode" style="font-size:16px;font-weight:600;letter-spacing:2px;">{{ obj.pickCode }}</span>
                            <span v-else style="color:#909399;">待支付后生成</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="提货电话">{{ obj.uphone }}</el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions title="退款信息" v-if="obj.subRefundTime" :column="2">
                        <el-descriptions-item label="申请退款时间">{{ obj.subRefundTime }}</el-descriptions-item>
                        <el-descriptions-item label="退款理由">{{ obj.refundRemark }}</el-descriptions-item>
                        <el-descriptions-item label="退款时间" v-if="obj.refundTime">{{ obj.refundTime
                            }}</el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions title="其他信息" :column="2">
                        <el-descriptions-item label="订单备注">{{ obj.remark ? obj.remark : '无' }} </el-descriptions-item>
                        <el-descriptions-item label="卡片留言">{{ obj.cardMsg ? obj.cardMsg : '无' }} </el-descriptions-item>
                        <el-descriptions-item :label="obj.psMode == 1 ? '自提时间' : '送出日期'">
                            <el-tag size="small">
                                {{ obj.deliveryDate ? obj.deliveryDate : '无' }}
                            </el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="匿名送出">
                            <el-tag v-if="obj.isAnonymous == 1" size="small" type="danger">是</el-tag>
                            <span v-else style="color:#999;">否</span>
                        </el-descriptions-item>
                    </el-descriptions>

                </el-tab-pane>
                <el-tab-pane label="下单商品" name="yj">
                    <el-table :data="goodList" border class="table table-then-card">
                        <el-table-column prop="title" label="商品标题"></el-table-column>
                        <el-table-column label="规格" align="center" width="220">
                            <template slot-scope="scope">
                                <div v-if="scope.row.seasonSpec || scope.row.color" style="text-align:left;display:inline-block;">
                                    <div v-if="scope.row.seasonSpec" style="margin-bottom:4px;">
                                        <span style="color:#909399;font-size:12px;">季节规格：</span>
                                        <el-tag size="mini">{{ scope.row.seasonSpec }}</el-tag>
                                    </div>
                                    <div v-if="scope.row.color">
                                        <span style="color:#909399;font-size:12px;">花束颜色：</span>
                                        <el-tag size="mini" type="info">{{ scope.row.color }}</el-tag>
                                    </div>
                                </div>
                                <span v-else style="color:#909399;">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="商品图片(点击查看)" align="center" prop="imgList" width="180">
                            <template slot-scope="scope">
                                <el-image class="table-td-thumb" preview-teleported :src="scope.row.imgList[0]"
                                    :preview-src-list="[scope.row.imgList[0]]" :z-index="10">
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" label="商品价格" width="180" align="center"></el-table-column>
                        <el-table-column prop="num" label="下单数量" width="180" align="center"></el-table-column>
                    </el-table>
                    <!-- 手机端卡片列表 - 下单商品 -->
                    <div class="mobile-card-list">
                        <div v-for="(row, idx) in goodList" :key="idx" class="mc-card">
                            <div class="mc-thumb-area">
                                <el-image class="mc-img" preview-teleported :src="row.imgList && row.imgList[0]"
                                    :preview-src-list="row.imgList" :z-index="10" fit="cover"></el-image>
                                <div class="mc-thumb-info">
                                    <div class="mc-title">{{ row.title }}</div>
                                    <div v-if="row.seasonSpec || row.color" style="margin-top:6px;">
                                        <div v-if="row.seasonSpec" style="margin-bottom:4px;">
                                            <span style="color:#909399;font-size:12px;">季节规格：</span>
                                            <el-tag size="mini">{{ row.seasonSpec }}</el-tag>
                                        </div>
                                        <div v-if="row.color">
                                            <span style="color:#909399;font-size:12px;">花束颜色：</span>
                                            <el-tag size="mini" type="info">{{ row.color }}</el-tag>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mc-grid-2">
                                <div class="mc-row">
                                    <span class="mc-label">价格</span>
                                    <span class="mc-value mc-value-danger">¥{{ row.price }}</span>
                                </div>
                                <div class="mc-row">
                                    <span class="mc-label">数量</span>
                                    <span class="mc-value">{{ row.num }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="goodList.length === 0" style="text-align:center;color:#909399;padding:20px 0;">暂无商品</div>
                    </div>
                    <div class="pagination">
                        <el-pagination @current-change="handleCurrentChangeG" :current-page.sync="pageG"
                            :page-size="sizeG" layout="total, prev, pager, next"
                            :total="goodList ? goodList.length : 0">
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
    </div>
</template>

<script>
import { queryOrders, querySearchOrders, putOrdersShipment, putOrdersRefund, putOrdersNoRefund, postOrderAccomplish, postOrderVerify } from '@/api';
export default {
    name: "UserAdmin",
    data() {
        return {
            imgUrl: '',
            xx: false,
            activeName: 'first',
            loading: true,
            loadingI: true,
            disfle: true,
            lod: false,
            uid: null,
            dingdan:0,
            // 实时监听状态：'connected' | 'disconnected' | 'reconnecting'
            liveStatus: 'disconnected',
            liveTimer: null,
            // 新到达的订单 ID 集合，用于高亮
            newOrderIds: [],
            // 自动刷新防抖定时器
            refreshTimer: null,
            // 倒计时相关
            countdownTimers: [],
            countdownData: {},
            fhObj: {
                oid: '',
                trackingNumber: '',
                logisticsCompany: ''
            },
            obj: {
                goodsList: []
            },
            pageG: 1,
            sizeG: 5,
            //发货弹窗
            fhFlag: false,
            //核销弹窗
            verifyFlag: false,
            verifyPickCode: '',
            verifyLoading: false,
            verifyOrderInfo: null,
            //订单状态
            status: 0,
            //订单选择列表
            selectStatus: [
                {
                    name: '全部',
                    status: 0
                },
                {
                    name: '待付款',
                    status: 1
                },
                {
                    name: '待发货',
                    status: 2
                },
                {
                    name: '待收货',
                    status: 3
                },
                {
                    name: '申请退款',
                    status: 4
                },
                {
                    name: '已退款',
                    status: 5
                },
                {
                    name: '已完成',
                    status: 6
                },
                {
                    name: '已取消',
                    status: 7
                },
                {
                    name: '待提货',
                    status: 8
                },
            ],
            //订单数据
            tableData: [],
            page: 1,
            size: 10,
            total: 0,
            upg: false,
            upInfo: {},
            //搜索
            str: '',
            rules: {
                nickname: [
                    { required: true, message: "请输入账号", trigger: "blur" }
                ],
                avatarUrl: [
                    { required: true, message: "请上传头像", trigger: "blur" }
                ]
            },
            ruless: {
                trackingNumber: [
                    { required: true, message: "发货单号不能为空", trigger: "blur" }
                ],
                logisticsCompany: [
                    { required: true, message: "配送公司不能为空", trigger: "blur" }
                ]
            },
            verifyRules: {
                pickCode: [
                    { required: true, message: "提货码不能为空", trigger: "blur" }
                ]
            }
        };
    },
    computed: {
        dialogWidth() {
            return window.innerWidth < 768 ? '95%' : '70%';
        },
        dialogWidthSmall() {
            return window.innerWidth < 768 ? '95%' : '500px';
        },
        statusText() {
            const map = { 1: '待付款', 2: '待发货', 3: '待收货', 4: '申请退款', 5: '已退款', 6: '已完成', 7: '已取消', 8: '待提货' };
            return (s) => map[s] || '未知';
        },
        statusTagType() {
            const map = { 1: 'warning', 2: '', 3: '', 4: 'danger', 5: 'danger', 6: 'success', 7: 'info', 8: '' };
            return (s) => map[s] || '';
        },
        payStatusText() {
            const map = { 0: '未支付', 1: '已支付', 2: '已退款' };
            return (s) => map[s] || '-';
        },
        payStatusTagType() {
            const map = { 0: 'warning', 1: 'success', 2: 'danger' };
            return (s) => map[s] || '';
        },
        goodList() {
            return this.obj.goodsList
                ? this.obj.goodsList.slice(
                    (this.pageG - 1) * this.sizeG,
                    this.pageG * this.sizeG
                )
                : [];
        }
    },
    watch: {
        str: {
            handler(val) {
                if (val) {
                    this.disfle = false
                } else {
                    this.disfle = true
                    this.getData();
                }
            }
        },
        // 监听订单提醒
        "$store.state.remind"(newValue, oldValue) {
            this.dingdan = newValue.num
        },
        // 监听 Vuex 中的 WebSocket 连接状态
        "$store.state.wsStatus"(status) {
            this.liveStatus = status;
        },
        // 监听 WebSocket 订单事件，实时刷新列表
        "$store.state.lastOrderEvent"(evt) {
            if (!evt) return;
            // 记录新订单 ID 用于高亮展示
            if (evt.orderId) {
                this.newOrderIds.push(evt.orderId);
                setTimeout(() => {
                    this.newOrderIds = this.newOrderIds.filter(id => id !== evt.orderId);
                }, 15000);
            }
            // 订单自动取消事件，额外提示
            if (evt.type == 6) {
                this.$notify({ title: '订单自动取消', message: evt.content || '有订单因超时未支付已自动取消', type: 'warning', duration: 5000 });
            }
            // 订单核销提货事件
            if (evt.type == 7) {
                this.$notify({ title: '订单核销完成', message: evt.content || '有订单已核销提货', type: 'success', duration: 5000 });
            }
            // 防抖自动刷新（1s 内多次事件只刷新一次）
            if (this.refreshTimer) clearTimeout(this.refreshTimer);
            this.refreshTimer = setTimeout(() => {
                this.getData();
            }, 800);
        }
    },
    methods: {
        // 标注新到达的订单行样式
        rowClassName({ row }) {
            return this.newOrderIds.indexOf(row.oid) !== -1 ? 'row-new-order' : '';
        },
        // ==================== 倒计时 ====================
        startCountdown(list) {
            this.clearCountdown();
            const countdownData = {};
            const timers = [];
            const now = Date.now();
            list.forEach(row => {
                if (row.status == 1 && row.expireTime) {
                    const expire = new Date(row.expireTime.replace(/-/g, '/')).getTime();
                    if (expire <= now) {
                        // 已过期的订单只显示00:00，不启动定时器，避免归零后循环刷新
                        this.$set(countdownData, row.oid, '00:00');
                        return;
                    }
                    this.updateCountdown(row.oid, row.expireTime, countdownData);
                    const timer = setInterval(() => {
                        this.updateCountdown(row.oid, row.expireTime, this.countdownData);
                    }, 1000);
                    timers.push(timer);
                }
            });
            this.countdownData = countdownData;
            this.countdownTimers = timers;
        },
        updateCountdown(oid, expireTime, data) {
            const now = Date.now();
            const expire = new Date(expireTime.replace(/-/g, '/')).getTime();
            const diff = expire - now;
            if (diff <= 0) {
                this.$set(data, oid, '00:00');
                // 立即清除所有倒计时定时器，防止每秒重复触发刷新
                this.clearCountdown();
                // 若WebSocket已连接，由WS事件触发刷新；否则做一次延迟兜底刷新
                if (this.liveStatus !== 'connected' && !this._pendingCountdownRefresh) {
                    this._pendingCountdownRefresh = true;
                    setTimeout(() => {
                        this._pendingCountdownRefresh = false;
                        this.getData();
                    }, 3000);
                }
                return;
            }
            const minutes = Math.floor(diff / 60000);
            const seconds = Math.floor((diff % 60000) / 1000);
            const text = (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
            this.$set(data, oid, text);
        },
        clearCountdown() {
            this.countdownTimers.forEach(t => clearInterval(t));
            this.countdownTimers = [];
        },
        // 同步 WebSocket 连接状态
        updateLiveStatus() {
            this.liveStatus = this.$store.state.wsStatus;
        },
        //筛选订单状态
        onChangeOrderStatus(status) {
            this.page = 1;
            this.loading = true;
            this.status = status;
            this.getData();
        },
        // 刷新订单
        refresh_order() {
            this.loading = true;
            this.page = 1;
            this.status = 0;
            localStorage.setItem('order_num', 0)
            this.$store.commit('order_remind', 0)
            this.getData();
        },
        //发货弹窗
        handleOrderSipping(index, row) {
            this.fhObj.oid = row.oid;
            this.fhFlag = true;
        },
        //核销提货弹窗
        handleVerifyPickUp(index, row) {
            this.verifyPickCode = (row && row.pickCode) || '';
            this.verifyOrderInfo = row;
            this.verifyFlag = true;
        },
        //提交核销
        subVerify() {
            this.$refs.verifyForm.validate((valid) => {
                if (!valid) return false;
                this.$confirm("是否确认核销该提货码?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(async () => {
                    this.verifyLoading = true;
                    try {
                        const res = await postOrderVerify({ pickCode: this.verifyPickCode.trim() });
                        if (res.code != 0) {
                            this.$message.error(res.msg || '核销失败');
                            return;
                        }
                        this.$message.success(res.msg || '核销成功');
                        this.verifyFlag = false;
                        this.verifyPickCode = '';
                        this.verifyOrderInfo = null;
                        this.loading = true;
                        this.getData();
                    } catch (e) {
                        this.$message.error('核销失败，请重试');
                    } finally {
                        this.verifyLoading = false;
                    }
                });
            });
        },
        //查看详情
        handleLook(index, row) {
            this.obj = row;
            this.xx = true;
        },
        // 一键复制收货信息
        copyRecipientInfo() {
            const name = this.obj.recipientName || '';
            const phone = this.obj.recipientPhone || '';
            const address = this.obj.recipientAddress || '';
            const text = name + ' ' + phone + '\n' + address;
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(() => {
                    this.$message.success('收货信息已复制');
                }).catch(() => {
                    this.fallbackCopy(text);
                });
            } else {
                this.fallbackCopy(text);
            }
        },
        fallbackCopy(text) {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                this.$message.success('收货信息已复制');
            } catch (e) {
                this.$message.error('复制失败，请手动复制');
            }
            document.body.removeChild(textarea);
        },
        //确认发货
        subFh(formName) {
            this.$refs[formName].validate((volid) => {
                if (volid) {
                    this.$confirm("是否确定该信息发货?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        putOrdersShipment(this.fhObj).then((res) => {
                            this.fhFlag = false;
                            let { code, msg } = res;
                            if (code != 0) {
                                this.$message.warning(msg);
                                return false;
                            }
                            this.getData();
                            this.fhObj = {};
                            this.$message.success(msg);
                        })
                    })

                } else {
                    return false;
                }
            })
        },
        //操作订单状态
        handleOrderStatus(index, row, n) {
            let { oid, uid, status } = row;
            let mm = '';
            if (status == 4) {
                mm = n == 0 ? '同意退款' : '拒绝退款'
            } else if (status == 8) {
                mm = '该用户已提货完成'
            }
            this.$confirm(`是否确定${mm}?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                let res = null;
                switch (status) {
                    case 4:
                        if (n == 0) {
                            const loading = this.$loading({ lock: true, text: '退款中...', background: 'rgba(255, 255, 255, 0.6)' });
                            res = await putOrdersRefund({ oid });
                            loading.close();
                        } else {
                            res = await putOrdersNoRefund({ oid });
                        }
                        if (res.code != 0) {
                            this.$message.error(res.msg);
                            return false;
                        }
                        this.$message.success(res.msg);
                        break;
                    case 8:
                        res = await postOrderAccomplish({ oid, uid });
                        if (res.code != 0) {
                            this.$message.error('确认失败,请联系开发者！！！');
                            return false;
                        }
                        this.$message.success('该订单已确定成功！！！');
                        break;
                    default:
                        break;
                }
                this.loading = true;
                this.getData();
            })



        },
        //搜索
        handleSearch() {
            this.page = 1;
            this.loading = true;
            this.lod = true;
            this.getData();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getData();
        },
        handleCurrentChangeG(val) {
            this.pageG = val;
        },
        async getData() {
            try {
                this.loading = true;
                let pageNum = this.page;
                let pageSize = this.size;
                let status = this.status;
                let str = this.str;
                let res = null;
                if (str) {
                    res = await querySearchOrders({ pageNum, pageSize, str, status });
                } else {
                    res = await queryOrders({ pageNum, pageSize, status });
                }
                this.tableData = res.list;
                this.total = res.total;
                // 启动待付款订单倒计时
                this.startCountdown(res.list || []);
                setTimeout(() => {
                    if (str) {
                        this.lod = false;
                    }
                    this.loading = false;
                }, 500)
            } catch (error) {
                this.$message.error('服务器错误');
            }
        }
    },
    created() {
        this._pendingCountdownRefresh = false;
        this.imgUrl = this.$base.url;
        // 读取路由传参，支持首页数据概览卡片跳转时自动筛选对应订单状态
        const queryStatus = this.$route && this.$route.query && this.$route.query.status;
        if (queryStatus !== undefined && queryStatus !== null && queryStatus !== '') {
            const s = parseInt(queryStatus);
            if (!isNaN(s)) {
                this.status = s;
            }
        }
        this.getData();
        // 订单提醒
        this.dingdan = localStorage.getItem("order_num")
        // 实时监听状态指示
        this.updateLiveStatus();
        this.liveTimer = setInterval(this.updateLiveStatus, 3000);
    },
    beforeDestroy() {
        if (this.liveTimer) clearInterval(this.liveTimer);
        if (this.refreshTimer) clearTimeout(this.refreshTimer);
        this.clearCountdown();
    },
};
</script>

<style scoped>
.order-page {
    height: calc(100vh - 110px);
    overflow-y: auto;
}

.pp {
    margin-top: 10px;
    float: right;
    color: #909399;
}

.handle-box {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 10px;
}

.handle-box-left {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.search-input {
    width: 220px;
}

.search-select {
    width: 160px;
}

.table {
    width: 100%;
    font-size: 14px;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.avatar-uploader {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    border-radius: 6px;
    border: 1px #cdcdcd dashed;
    height: 150px;
    cursor: pointer;
}

.avatar-uploader-icon {
    font-size: 26px;

}

.avatar {
    width: 150px;
    height: 150px;
    border-radius: 6px;
}

.button-view {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 30px;
}

.live-tag {
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 12px;
    margin-right: 12px;
    user-select: none;
}

.live-on {
    color: #67c23a;
    background: #f0f9eb;
    border: 1px solid #e1f3d8;
}

.live-off {
    color: #909399;
    background: #f4f4f5;
    border: 1px solid #e9e9eb;
}

.live-reconnecting {
    color: #e6a23c;
    background: #fdf6ec;
    border: 1px solid #faecd8;
}

.live-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 6px;
    background: currentColor;
}

.live-on .live-dot {
    animation: livePulse 1.4s infinite;
}

.live-reconnecting .live-dot {
    animation: liveBlink 1s infinite;
}

@keyframes livePulse {
    0%   { box-shadow: 0 0 0 0 rgba(103, 194, 58, 0.6); }
    70%  { box-shadow: 0 0 0 8px rgba(103, 194, 58, 0); }
    100% { box-shadow: 0 0 0 0 rgba(103, 194, 58, 0); }
}

@keyframes liveBlink {
    0%, 100% { opacity: 1; }
    50%      { opacity: 0.3; }
}

/* 手机端适配 */
@media (max-width: 767px) {
  .order-page {
    height: calc(100vh - 56px);
  }
  .handle-box {
    flex-direction: column;
    align-items: stretch;
  }
  .handle-box-left {
    flex-direction: column;
  }
  .search-input {
    width: 100%;
  }
  .search-select {
    width: 100%;
  }
  .button-view {
    margin-bottom: 0;
    justify-content: flex-start;
  }
}

/* 平板端适配 */
@media (min-width: 768px) and (max-width: 1024px) {
  .order-page {
    height: calc(100vh - 56px);
  }
  .search-input {
    width: 180px;
  }
}

/* 新到达订单高亮（需穿透 el-table 子组件） */
.table >>> .row-new-order td {
    background-color: #fff8e1 !important;
    animation: rowFlash 1.6s ease-in-out 2;
}

@keyframes rowFlash {
    0%   { background-color: #fff8e1; }
    50%  { background-color: #ffe8a3; }
    100% { background-color: #fff8e1; }
}
</style>